// Formatacoes compartilhadas da tela de licencas.

// versao em inteiro XX*10000+YY*100+ZZ (padrao da casa) -> "10.9.1"
export function formataVersao(numero) {
  const n = Number(numero) || 0;
  if (!n) {
    return '';
  }
  return `${Math.floor(n / 10000)}.${Math.floor(n / 100) % 100}.${n % 100}`;
}

export function formataDataHora(valor) {
  return valor ? new Date(valor).toLocaleString('pt-BR') : '';
}

// 'yyyy-MM-dd' -> 'dd/MM/yyyy' (sem passar por Date: evita o deslocamento de fuso)
export function formataData(valor) {
  if (!valor) {
    return '';
  }
  const [ano, mes, dia] = String(valor)
    .substring(0, 10)
    .split('-');
  return `${dia}/${mes}/${ano}`;
}

// licenca de teste: fim = ativacao + dias (null = normal, ou teste ainda nao ativado)
export function fimTeste(licenca) {
  if (!licenca || !(licenca.diasTeste > 0) || !licenca.dataHoraAtivacao) {
    return null;
  }
  return new Date(new Date(licenca.dataHoraAtivacao).getTime() + licenca.diasTeste * 864e5);
}

// coluna/campo "Tipo": Normal, Teste (N dias) antes de ativar, Teste ate dd/mm hh:mm
export function textoTipo(licenca) {
  if (!licenca || !(licenca.diasTeste > 0)) {
    return 'Normal';
  }
  const fim = fimTeste(licenca);
  return fim
    ? `Teste até ${fim.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })}`
    : `Teste (${licenca.diasTeste} dia(s))`;
}

export const OPCOES_TIPO_CHAVE = [
  { label: 'Normal (instalação do cliente)', value: 'normal' },
  { label: 'Teste (simular o cliente)', value: 'teste' },
];

export const OPCOES_DIAS_TESTE = [
  { label: '1 dia', value: 1 },
  { label: '2 dias', value: 2 },
  { label: '3 dias', value: 3 },
];

// licenca_instalacao.situacao
export const SITUACAO = {
  AGUARDANDO_ATIVACAO: 0,
  ATIVA: 1,
  REVOGADA: 2,
  CANCELADA: 3,
};

export const NOMES_SITUACAO = {
  0: 'Aguardando ativação',
  1: 'Ativa',
  2: 'Revogada',
  3: 'Cancelada',
};

// aguardando = amarelo, ativa = verde, revogada = vermelho, cancelada = cinza
export const CORES_SITUACAO = {
  0: '#d39e00',
  1: '#28a745',
  2: '#dc3545',
  3: '#6c757d',
};

// licenca_evento.tipo
export const TIPOS_EVENTO = {
  1: 'Ativação',
  2: 'Renovação',
  3: 'Token divergente (clone?)',
  4: 'Bloqueio por clone',
  5: 'Desbloqueio de clone',
  6: 'Código de desbloqueio',
};

export const OPCOES_SITUACAO = [
  { label: 'Todas', value: '' },
  { label: 'Aguardando ativação', value: 0 },
  { label: 'Ativas', value: 1 },
  { label: 'Revogadas', value: 2 },
  { label: 'Canceladas', value: 3 },
];
